// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stripe-checkout-form-container {
  margin-top: 16px;
}

.stripe-checkout-form-container .payment-info-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.02em;
}

.stripe-checkout-form-container .button-container {
  margin-top: 20px;
}
.stripe-checkout-form-container .button-container .btn {
  --button-background-primary: var(--orange);
  border-radius: 32px;
}

.stripe-checkout-form-container .engine-container {
  margin-top: 20px;
  margin-bottom: 7px;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.02em;
  text-align: center;
}
.stripe-checkout-form-container .payment-method-icons {
  width: 100%;
  justify-content: space-between;
  margin-top: 0;
  margin-left: 0;
  margin-right: 0;
  margin-bottom: 16px;
  padding-left: 10px;
  padding-right: 10px;
}

.stripe-checkout-form-container .payment-method-icons .icon-container {
  width: 64px;
  justify-content: center;
}

.stripe-checkout-form-container .payment-method-icons .icon-container svg {
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
}

.stripe-checkout-form-container .payment-method-icons .maestro svg {
  width: 32px;
  height: auto;
}
.stripe-checkout-form-container .payment-method-icons .master-card svg {
  width: 32px;
  height: auto;
}

.stripe-checkout-form-container .input-error-message {
    font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.stripe-checkout-form.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,8BAA8B;EAC9B,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".stripe-checkout-form-container {\n  margin-top: 16px;\n}\n\n.stripe-checkout-form-container .payment-info-container {\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 18px;\n  letter-spacing: 0.02em;\n}\n\n.stripe-checkout-form-container .button-container {\n  margin-top: 20px;\n}\n.stripe-checkout-form-container .button-container .btn {\n  --button-background-primary: var(--orange);\n  border-radius: 32px;\n}\n\n.stripe-checkout-form-container .engine-container {\n  margin-top: 20px;\n  margin-bottom: 7px;\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: 0.02em;\n  text-align: center;\n}\n.stripe-checkout-form-container .payment-method-icons {\n  width: 100%;\n  justify-content: space-between;\n  margin-top: 0;\n  margin-left: 0;\n  margin-right: 0;\n  margin-bottom: 16px;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.stripe-checkout-form-container .payment-method-icons .icon-container {\n  width: 64px;\n  justify-content: center;\n}\n\n.stripe-checkout-form-container .payment-method-icons .icon-container svg {\n  width: 100%;\n  max-width: 100%;\n  height: 100%;\n  max-height: 100%;\n}\n\n.stripe-checkout-form-container .payment-method-icons .maestro svg {\n  width: 32px;\n  height: auto;\n}\n.stripe-checkout-form-container .payment-method-icons .master-card svg {\n  width: 32px;\n  height: auto;\n}\n\n.stripe-checkout-form-container .input-error-message {\n    font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
